/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'deleteCustomerRewardLimitsBySystemGameId',
    message: messages.SUCCESS_DELETE_CUSTOMER_REWARD_LIMITS_BY_SYSTEM_GAME_ID,
    method: 'DELETE',
    path: '/customer/:customerId/reward-limits/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_REWARD_LIMIT,
    rewardSchema: requestSchemas.customerRewardLimits.deleteCustomerRewardLimitsBySystemGameId,
  },
  {
    action: 'getCustomerRewardLimitPackageByCompositeKey',
    message: messages.SUCCESS_GET_CUSTOMER_REWARD_LIMIT_PACKAGE_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/customer/:customerId/reward-limit-package/:compositeKey',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_REWARD_LIMIT_PACKAGE,
    rewardSchema: requestSchemas.customerRewardLimits.getCustomerRewardLimitPackageByCompositeKey,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'getCustomerRewardLimitsBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_REWARD_LIMITS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/reward-limits/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_REWARD_LIMIT,
    rewardSchema: requestSchemas.customerRewardLimits.getCustomerRewardLimitsBySystemGameId,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'saveCustomerRewardLimitsBySystemGameId',
    message: messages.SUCCESS_SAVE_CUSTOMER_REWARD_LIMITS_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/customer/:customerId/reward-limits/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.SAVE_CUSTOMER_REWARD_LIMIT,
    rewardSchema: requestSchemas.customerRewardLimits.saveCustomerRewardLimitsBySystemGameId,
  },
];
